export type CommentType = {
    id: string;
    name: string;
    icon: string;
    color: string;
}

export const LINE_COMMENT_TYPE_NONE_CONFIG: CommentType = {
    id: 'none',
    name: 'Geen',
    icon: '',
    color: ''
};

export const LINE_COMMENT_TYPE_CONFIGS: CommentType[] = [
    {
        id: 'comment',
        name: 'Opmerking',
        icon: 'fas fa-solid fa-comment',
        color: '#9f9f9f'
    },
    {
        id: 'check',
        name: 'Check',
        icon: 'fas fa-solid fa-circle-question',
        color: '#74d71c'
    },
    {
        id: 'old',
        name: 'Vervallen',
        icon: 'fas fa-solid fa-circle-minus',
        color: '#df0000'
    },
    {
        id: 'change',
        name: 'Wijziging',
        icon: 'fas fa-solid fa-circle-exclamation',
        color: '#ff9a00'
    },
    {
        id: 'deductible',
        name: 'Verrekenbaar',
        icon: 'fas fa-solid fa-money-check-dollar',
        color: '#00cfff'
    },
    LINE_COMMENT_TYPE_NONE_CONFIG
];